function initSectionHighlight(
  navContainerSelector,
  sectionContainerSelector,
  scrollOffset = 0
) {
  // Get all navigation links and sections
  const navLinks = document.querySelectorAll(`${navContainerSelector} a`);
  const sections = document.querySelectorAll(
    `${sectionContainerSelector} section`
  );

  // Prevent default behavior and add smooth scroll with offset
  navLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - scrollOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  // Create intersection observer
  const observerOptions = {
    root: null,
    rootMargin: "-50% 0px",
    threshold: 0,
  };

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      const targetId = entry.target.getAttribute("id");
      const correspondingLink = document.querySelector(
        `${navContainerSelector} a[href="#${targetId}"]`
      );

      if (entry.isIntersecting) {
        navLinks.forEach((link) => link.classList.remove("active-section"));
        correspondingLink?.classList.add("active-section");
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // Observe all sections
  sections.forEach((section) => {
    if (section.id) {
      observer.observe(section);
    }
  });

  // Return cleanup function
  return () => {
    sections.forEach((section) => {
      observer.unobserve(section);
    });
    observer.disconnect();
  };
}

// Usage example:
document.addEventListener("DOMContentLoaded", () => {
  // Initialize with a 100px offset from the top
  initSectionHighlight(".nav-link-list-container", ".section-container", 100);

  // Initialize another section with different offset if needed
  initSectionHighlight(
    ".another-nav-container",
    ".another-section-container",
    80
  );
});

(function () {
  // Get the button
  const scrollButton = document.getElementById("scrolling");

  if (!scrollButton) return;

  // Get the custom attributes
  const scrollSpeed =
    parseInt(scrollButton.getAttribute("data-scroll-speed")) || 400;
  const startScroll =
    parseInt(scrollButton.getAttribute("data-start-scroll")) || 300;

  // Show/hide button based on scroll position
  window.addEventListener("scroll", function () {
    if (window.scrollY > startScroll) {
      scrollButton.classList.add("top-visible");
    } else {
      scrollButton.classList.remove("top-visible");
    }
  });

  // Smooth scroll to top functionality
  scrollButton.addEventListener("click", function (e) {
    e.preventDefault();

    const startPosition = window.pageYOffset;
    const startTime = performance.now();

    function scrollToTop(currentTime) {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / scrollSpeed, 1);

      // Easing function for smooth animation
      const easeInOutCubic = (progress) => {
        return progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      };

      window.scrollTo(0, startPosition * (1 - easeInOutCubic(progress)));

      if (progress < 1) {
        requestAnimationFrame(scrollToTop);
      }
    }

    requestAnimationFrame(scrollToTop);
  });

  // Optional: Add hover animation for the mouse/arrows
  scrollButton.addEventListener("mouseenter", function () {
    const arrows = this.querySelector(".scroll-to-top__arrows");
    if (arrows) {
      arrows.classList.add("animated");
    }
  });

  scrollButton.addEventListener("mouseleave", function () {
    const arrows = this.querySelector(".scroll-to-top__arrows");
    if (arrows) {
      arrows.classList.remove("animated");
    }
  });
})();

// Save this as dynamic-heading.js in your theme's js folder
jQuery(document).ready(function ($) {
  function rotateText() {
    const container = $("#foter-rotation");
    const interval = container.data("interval") || 2000;
    const items = container.find(".cycleText");
    let current = 0;

    setInterval(function () {
      items.css("display", "none");
      current = (current + 1) % items.length;
      items.eq(current).css("display", "inline-block");
    }, interval);
  }

  if ($("#foter-rotation").length) {
    rotateText();
  }
});

/**
 * URL Parameter Capture and Display Script (Final Version)
 * - Captures URL parameters
 * - Displays in div.dynamicFormText h2 element with double quotes if parameter exists
 * - Removes h2 element completely if no parameter exists
 * - Replaces + with spaces
 * - Sets hidden input value (without quotes)
 * - Only runs on WordPress page ID 89
 */
(function () {
  // Function to check if we're on the correct page
  function isTargetPage() {
    // Check if we're on page ID 89
    return document.body.classList.contains("page-id-10656");
  }

  // Function to get URL parameters
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Function to get all URL parameters as an object
  function getAllUrlParameters() {
    const params = {};
    const queryString = window.location.search.substring(1);

    if (queryString) {
      const pairs = queryString.split("&");
      for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split("=");
        params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
      }
    }

    return params;
  }

  // Main function to handle the functionality
  function handleUrlParameters() {
    if (!isTargetPage()) {
      return; // Exit if not on page ID 89
    }

    // Get all URL parameters
    const params = getAllUrlParameters();

    // Get the 'trip' parameter or use empty string if not found
    let tripValue = params["trip"] || "";

    // Replace any remaining '+' characters with spaces
    tripValue = tripValue.replace(/\+/g, " ");

    // Update the div.dynamicFormText h2 element
    const dynamicTextContainers = document.querySelectorAll(".dynamicFormText");
    dynamicTextContainers.forEach((container) => {
      const h2 = container.querySelector("h2");

      if (tripValue.trim() === "") {
        // If no trip value, remove the h2 element completely
        if (h2) {
          h2.remove();
        }
      } else {
        // If trip value exists, display it with quotes
        if (h2) {
          h2.textContent = `"${tripValue}"`;
        } else {
          // If h2 was previously removed, create a new one
          const newH2 = document.createElement("h2");
          newH2.textContent = `"${tripValue}"`;
          container.appendChild(newH2);
        }
      }
    });

    // Update the hidden input value - no quotes for the form submission value
    const hiddenInput = document.querySelector(
      'input[name="dynamic_form_field"]'
    );
    if (hiddenInput) {
      hiddenInput.value = tripValue;
    }
  }

  // Run when DOM is fully loaded
  document.addEventListener("DOMContentLoaded", handleUrlParameters);
})();

// Rating functionality
document.addEventListener("DOMContentLoaded", function () {
  const stars = document.querySelectorAll('.stars a[role="radio"]');

  // Function to update rated stars
  function updateRated(currentStar) {
    const currentIndex = Array.from(stars).indexOf(currentStar);
    stars.forEach((star, index) => {
      if (index <= currentIndex) {
        star.classList.add("rated");
      } else {
        star.classList.remove("rated");
      }
    });
  }

  // Initialize based on aria-checked
  stars.forEach((star) => {
    if (star.getAttribute("aria-checked") === "true") {
      updateRated(star);
    }
  });

  // Hover effect
  stars.forEach((star) => {
    star.addEventListener("mouseenter", () => updateRated(star));
    star.addEventListener("mouseleave", () => {
      // Reset to the selected rating
      const selectedStar = document.querySelector(
        '.stars a[aria-checked="true"]'
      );
      if (selectedStar) {
        updateRated(selectedStar);
      } else {
        stars.forEach((s) => s.classList.remove("rated"));
      }
    });

    // Click sets aria-checked
    star.addEventListener("click", (e) => {
      e.preventDefault();
      stars.forEach((s) => s.setAttribute("aria-checked", "false"));
      star.setAttribute("aria-checked", "true");
      updateRated(star);
    });
  });
});
